import { useTranslation } from 'react-i18next'

import { useNavigate } from '@lib/react-router-dom'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

export const VerifyPhoneModal: BaseModalType = ({ close }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Verification Required')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t('To secure your bonus and protect your account, a verified phone number is required.')}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary
          onClick={() => {
            navigate('/profile/phone-numbers')
            close()
          }}
        >
          {t('PhoneNumbers.Verify')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
